import {StyledDemographicComponent} from "@clients/profile_page/ClientDemographicsNode.styles";
import {colors} from "patient-ping-remedy/packages/theme";
import React from "react";

type DemographicNodeProps = {
  label: string;
  value?: string | React.ReactNode;
  labelChildren?: React.ReactNode;
};

const ClientDemographicsNode: React.FC<DemographicNodeProps> = ({ label, value, labelChildren }) => {
  return (
    <>
      <StyledDemographicComponent color={colors.gray5} whiteSpace="nowrap">
        {label}
        {labelChildren && labelChildren}
      </StyledDemographicComponent>
      <br />
      <StyledDemographicComponent>
        {value || <br />}
      </StyledDemographicComponent>
    </>
  );
};

export default ClientDemographicsNode;
